import React, { useState } from "react";
import { toast } from "react-toastify";

import { FormHelperText, FormLabel, Input, Option, Select } from "@mui/joy";
import "../css/BeneficiarySignup.css";
import {
  addAttorneyInvitation,
  getExistAttorneyInvitationByUsername,
  sendemail,
  updateAttorneyInvitation,
} from "../services/user-service";
import { getToken, getUser } from "../services/user-service";

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CardHeader, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import "./../css/inventoryReport.css";
import { EmailTemplateForInviteAttorney } from "./Emailtemplate";

const AttorneyDetail = ({ handleBack, pdfDataUri }) => {
  const userDetails = getUser();

  const [data, setData] = useState({
    agentName: "",
    agentEmail: "",
    agentType: "",
    otherAgentType: "",
    userName: userDetails.username,
    userEmail: userDetails.email,
    isInvitationAccepted: false,
  });

  const [emailDetail] = useState({
    to: "",
    subject: "",
    message: "",
  });

 
const handleChanges = (event, property) => {
  let value = event.target.value;

  if (property === "agentEmail") {
    value = value.toLowerCase(); 
    validateEmail(value);
  }

  setData({ ...data, [property]: value });
};

  const handleSelectChanges = (e, newValue) => {
    const selectedAgentType = newValue || e.target.value;

    setData((prevData) => ({
      ...prevData,
      agentType: selectedAgentType,
      otherAgentType:
        selectedAgentType === "Other" ? prevData.otherAgentType : "",
    }));
  };

  const [errors, setErrors] = useState("");
  const [agentTypeError, setAgentTypeError] = useState("");
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErrors("Invalid email address");
    } else if (email !== email.toLowerCase()) {
      setErrors("Email should not contain capital letters");
    } else {
      setErrors("");
    }
  };

 
  const submitForm = (event) => {
    event.preventDefault();

    if (!data.agentType) {
      setAgentTypeError("Please select Agent Type");
      return;
    }

    setAgentTypeError("");

    if (errors) {
      toast.error("Invalid email address", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    emailDetail.to = data.agentEmail;
    emailDetail.message = EmailTemplateForInviteAttorney(
      data.agentName,
      userDetails.email,
      userDetails.phoneNo
    );
    emailDetail.subject = "ATTORNEY INVITATION";

    const token = "Bearer " + getToken();

    const formData = new FormData();

    formData.append("data", JSON.stringify(data));

    const emailFormData = new FormData();
    emailFormData.append("emailDetails", JSON.stringify(emailDetail));

    
    const handleSendEmail = (emailFormData, agentName) => {
      sendemail(emailFormData)
        .then((resp) => {
          handleBack(); 
          toast.success(`Email has been sent to ${agentName}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        })
        .catch((error) => {
          toast.error("Email has not been sent", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        });
    };

    getExistAttorneyInvitationByUsername(token, data.userName)
      .then((res) => {
        if (res && res.agentEmail === data.agentEmail) {
          // ✅ same attorney, so update existing invite
          const updatedFormData = new FormData();
          updatedFormData.append("data", JSON.stringify({ ...data, id: res.id }));

          updateAttorneyInvitation(token, updatedFormData)
            .then(() => handleSendEmail(emailFormData, data.agentName))
            .catch(() =>
              toast.error("Error updating attorney invitation", {
                position: toast.POSITION.BOTTOM_CENTER,
              })
            );
        } else {
          // ✅ different attorney, so add a new invitation
          const formData = new FormData();
          formData.append("data", JSON.stringify(data));

          addAttorneyInvitation(token, formData)
            .then(() => handleSendEmail(emailFormData, data.agentName))
            .catch(() =>
              toast.error("Error adding attorney invitation", {
                position: toast.POSITION.BOTTOM_CENTER,
              })
            );
        }
      })
      .catch(() => {
        toast.error("Error checking existing attorney invitation", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      });
  };

  return (
    <div style={{ width: "100%" }}>
      <div style={{ width: "25rem" }}>
        <Card>
          <CardContent>
            <div className="cross_button">
              <button className="cross_button_main" onClick={handleBack}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <CardHeader
              title={
                <Typography
                  variant="h5"
                  style={{ textAlign: "center", marginTop: "-10px" }}
                >
                  Attorney/Agent Details
                </Typography>
              }
            />
            <form onSubmit={submitForm}>
              <div>
                <div className="mt-2">
                  <FormLabel>Select Agent</FormLabel>
                  <Select
                    value={data.agentType}
                    // required
                    onChange={(e, newValue) => handleSelectChanges(e, newValue)}
                  >
                    <Option value="">Select agent type</Option>
                    <Option value="Attorney">Attorney</Option>
                    <Option value="Executor">Executor</Option>
                    <Option value="Trustee">Trustee</Option>
                    <Option value="Advisor">Advisor</Option>
                    <Option value="Other">Other</Option>
                  </Select>
                  {agentTypeError && (
                      <FormHelperText style={{ color: "#C41C1C" }}>
                        {agentTypeError}
                      </FormHelperText>
                  )}
                </div>

                {data.agentType === "Other" && (
                  <div className="mt-2">
                    <div>
                      <FormLabel>Other Agent Type</FormLabel>
                      <Input
                        className="input_mui_joy"
                        placeholder="Enter Other Agent Type"
                        id="otherprop"
                        onChange={(e) => handleChanges(e, "otherAgentType")}
                        value={data.otherAgentType}
                      />
                    </div>
                  </div>
                )}

                <div className="mt-2">
                  <FormLabel>
                    {data.agentType === "Other" && data.otherAgentType
                      ? `Enter ${data.otherAgentType} Name`
                      : data.agentType
                      ? `Enter ${data.agentType} Name`
                      : "Enter Name"}
                  </FormLabel>
                  <Input
                    className="input_mui_joy"
                    placeholder={
                      data.agentType === "Other" && data.otherAgentType
                        ? `Enter ${data.otherAgentType} Name`
                        : data.agentType
                        ? `Enter ${data.agentType} Name`
                        : "Enter Name"
                    }
                    value={data.agentName}
                    onChange={(e) => handleChanges(e, "agentName")}
                    required
                  />
                </div>

                <div className="mt-2">
                  <FormLabel>
                    {data.agentType === "Other" && data.otherAgentType
                      ? `Enter ${data.otherAgentType} Email`
                      : data.agentType
                      ? `Enter ${data.agentType} Email`
                      : "Enter Email"}
                  </FormLabel>
                  <Input
                    className="input_mui_joy"
                    placeholder={
                      data.agentType === "Other" && data.otherAgentType
                        ? `Enter ${data.otherAgentType} Email`
                        : data.agentType
                        ? `Enter ${data.agentType} Email`
                        : "Enter Email"
                    }
                    value={data.agentEmail}
                    onChange={(e) => handleChanges(e, "agentEmail")}
                    error={!!errors}
                    required
                  />
                  {errors && (
                    <FormHelperText style={{ color: "#C41C1C" }}>
                      {errors}
                    </FormHelperText>
                  )}
                </div>
              </div>
              <div className="submit_button">
                <button type="submit">Send mail</button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AttorneyDetail;
